import { useGetQuery } from '@/hooks/api/useGetQuery';
import { queryKeys } from './query-keys';

export function useFestivalsQuery(type = 'all') {
  return useGetQuery(
    () => `/admin/festivals/${type}`,
    {},
    queryKeys.festivals(type),
    {},
  );
}
